import clsx from 'clsx';
import { useRouter } from 'next/dist/client/router';
import type { ReactElement } from 'react';
import { useMemo } from 'react';

import { RouteInfoProvider } from '../../contexts/route_info_context';
import routes from '../../routes';
import Presentation from '../videos/Presentation';

import Footer from './Footer';
import { Navbar } from './navbar/Navbar';
import {
  PresentationContextProvider,
  usePresentationContext,
} from './navbar/context/presentation';

export default function Layout(props: { children: ReactElement }) {
  const { pathname } = useRouter();
  const route = routes.find((element) => element.to === pathname);
  const showHeader = !route?.embedded;
  const showFooter = !route?.embedded && route?.isFooterVisible;
  const isNewsletterVisible =
    !route?.embedded && route?.isFooterVisible && route?.isNewsletterVisible;

  // Pages with the NMRium component don't have a scrollbar, so fixed navbar makes layout harder
  const isHeaderFixed = !route?.isNmrium;

  // The home page is special
  // The margin should be removed to use the screen height effectively

  const routeInfo = useMemo(() => {
    return {
      isNmrium: route?.isNmrium ?? false,
    };
  }, [route?.isNmrium]);
  return (
    <RouteInfoProvider value={routeInfo}>
      <div
        className={clsx('flex flex-col isolate', { 'h-dvh': route?.isNmrium })}
      >
        {showHeader && (
          <header className="z-[200]">
            <PresentationContextProvider>
              <Header isHeaderFixed={isHeaderFixed} />
            </PresentationContextProvider>
          </header>
        )}

        <div
          className={clsx('flex flex-1 flex-col', {
            'bg-primary-700': !route?.isWhite,
            'bg-white': route?.isWhite,
            // set the same height (corresponding to the header height) to the main content
            'pt-[68px]': showHeader && isHeaderFixed,
            'min-h-0': route?.isNmrium,
          })}
        >
          {props.children}
        </div>

        {showFooter && <Footer isNewsletterVisible={isNewsletterVisible} />}
      </div>
    </RouteInfoProvider>
  );
}

interface HeaderProps {
  isHeaderFixed: boolean;
}

function Header(props: HeaderProps) {
  const { isHeaderFixed } = props;
  const { showPresentation, setShowPresentation } = usePresentationContext();

  return (
    <>
      <Presentation
        show={showPresentation}
        onClose={() => {
          setShowPresentation(false);
        }}
        link="https://player.vod2.infomaniak.com/embed/1jhvl2uqn6wfm"
        title="Introduction to NMRium"
        description={`This video gives an overview of the main features of NMRium.`}
      />

      <Navbar isFixed={isHeaderFixed} />
    </>
  );
}
